import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModuleBase } from 'app/shared/models/module-base.model';
import { ModuleService } from 'app/shared/services/module.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-module-selection-list',
  templateUrl: './module-selection-list.component.html',
  styleUrls: ['./module-selection-list.component.scss']
})

export class ModuleSelectionListComponent implements OnInit {
  @Input() active: boolean = true;
  @Input() hideLabel: boolean = false;
  @Input() selectedModule: ModuleBase;
  @Input() selectModuleText: string;
  @Output() moduleChangedEvent: EventEmitter<ModuleBase> = new EventEmitter<ModuleBase>();

  moduleList$: Observable<ModuleBase[]>;
  moduleListLoading = false;
  moduleListinput$ = new Subject<string>();

  constructor(private moduleService: ModuleService) {
  }

  ngOnInit() {
    if (this.active) {
      this.loadModuleList();
    }
  }

  private loadModuleList() {
    this.moduleList$ = this.moduleService.getList<ModuleBase>("/module/list");
  }

  selectedModuleChanged(module: ModuleBase) {
    this.moduleChangedEvent.emit(module);
  }
}
